import React, { Suspense, lazy, useMemo } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { BaseRouteRedirect } from "./BaseRouteRedirect";
import { PageNotFound } from "./PageNotFound";
import Loader from "components/shared/loader";
import { isSuperUser } from "helpers/user";
import { useUser } from "users/hooks/useUser";

export const Routes = () => {
  const { data: user } = useUser();
  const MasterSwitch = useMemo(() => {
    if (!user?.email) {
      return null;
    }
    return isSuperUser(user.email)
      ? lazy(() =>
          import("./SuperUserSwitch").then((module) => ({
            default: module.SuperUserSwitch,
          }))
        )
      : Switch;
  }, [user?.email]);
  if (!MasterSwitch) {
    return <Loader />;
  }
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <MasterSwitch>
          <Route
            path="/:vendorLevel/:vendorLocation"
            component={lazy(() =>
              import("./MainAppContainer").then((module) => ({
                default: module.MainAppContainer,
              }))
            )}
          />
          <Route exact path="/" component={BaseRouteRedirect} />
          <Route component={PageNotFound} />
        </MasterSwitch>
      </Suspense>
    </BrowserRouter>
  );
};
